import { useContext, useEffect, useState } from 'react';
import { isOptionAllAreas } from '../../components/AreaSelect';
import { isOptionAllClaimTypes } from '../../components/ClaimTypeSelect';
import { AppContext } from '../../contexts/AppContext';
import { LoginContext } from '../../contexts/LoginContext';
import ClaimsAPI from '../../services/ClaimsAPI';
import { todayLastYear, YMD_FORMAT } from '../../utils/DateUtils';

export const CLAIM_STATUS = {
  ALL: 'Todos',
  OPEN: 'Abierto',
  CLOSED: 'Cerrado',
};

const useClaimManagementPresenter = () => {
  const { isSupplier, idSupplier } = useContext(LoginContext);
  const { showWarning, showError } = useContext(AppContext);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [area, setArea] = useState('');
  const [claimId, setClaimId] = useState('');
  const [claimType, setClaimType] = useState('');
  const [dateFrom, setDateFrom] = useState(null);
  const [claimStatus, setClaimStatus] = useState(CLAIM_STATUS.ALL);
  const [open, setOpen] = useState(false);

  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const [rows, setRows] = useState([]);

  const cleanFilters = () => {
    setSelectedSupplier(null);
    setClaimId('');
    setClaimType('');
    setDateFrom(null);
    setClaimStatus('');
  };

  const search = () => {
    const request = {
      id: !claimId.isBlank() ? claimId : undefined,
      cuit: isSupplier ? idSupplier : selectedSupplier?.cuit,
      idArea: !isOptionAllAreas(area) ? area : undefined,
      claimType: !isOptionAllClaimTypes(claimType) ? claimType : undefined,
      startDate: dateFrom ? dateFrom.format(YMD_FORMAT) : todayLastYear(),
      state: !(claimStatus.isBlank() || claimStatus == CLAIM_STATUS.ALL) ? claimStatus == CLAIM_STATUS.OPEN : undefined,
    };
    setLoading(true);
    setFirstLoad(false);
    ClaimsAPI.getClaims(request)
      .then(res => setRows(res))
      .catch(error => showError('Error al obtener los reclamos'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    isSupplier && search();
  }, []);

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    // if ((errors[i++] = !isSupplier && !selectedSupplier)) {
    //   errorMessages.push('Debe seleccionar un proveedor para iniciar la búsqueda');
    // }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  return {
    open,
    setOpen,
    rows,
    firstLoad,
    loading,
    reloadGrid: search,
    filterProps: {
      CLAIM_STATUS,
      selectedSupplier,
      setSelectedSupplier,
      area,
      setArea,
      claimId,
      setClaimId,
      claimType,
      setClaimType,
      dateFrom,
      setDateFrom,
      claimStatus,
      setClaimStatus,
      cleanFilters,
      validateAndSearch,
      rows,
    },
  };
};

export default useClaimManagementPresenter;
